export const Button = ({ children, submit, disabled, icon, iconEnd, gray, yellow, red, green, className, ...props }) => {
    return <button {...props} type={submit && !disabled ? undefined : "button"} className={`px-5 py-2 rounded-lg text-white flex gap-2 justify-center items-center ${disabled ? 'opacity-50 cursor-not-allowed' : ''} 
        ${red ? 'bg-red-500'
            : yellow ? 'bg-yellow-500 '
                : gray ? 'bg-gray-500 '
                    : green ? 'bg-green-600 '
                        : 'bg-blue-500 '
        } ${disabled ? '' : red ? 'hover:bg-red-600'
            : yellow ? 'hover:bg-yellow-600'
                : gray ? 'hover:bg-gray-600'
                    : green ? 'hover:bg-green-700'
                        : 'hover:bg-blue-600'
        } ${className}`} disabled={disabled ? true : undefined}>
        {!iconEnd && icon}
        {children}
        {iconEnd && icon}
    </button>
}